import { InstagramLogo } from '@phosphor-icons/react';

export default InstagramLogo;
